export default __webpack_public_path__ + "b243d96ce423c1a5b9bf3082e1989feb.webp";